// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountAdmin } from './account-admin';
import { AccountUser } from './account-user';
import { ActiveStatus } from './active-status';
import { ProximityRole } from './proximity-role';
import { ProximityUserNote } from './proximity-user-note';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags
import { Validator } from 'breeze-client';
import { EntityPropertyAnnotation, EntityTypeAnnotation } from '../entity-type-annotations';
import { StringFns } from '@utils';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProximityUser extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static getEntityTypeAnnotation(): EntityTypeAnnotation {
    const propAnnotations = [
      new EntityPropertyAnnotation('email', {
        validators: [Validator.emailAddress()],
      }),
    ];

    return new EntityTypeAnnotation({
      validators: [],
      propertyAnnotations: propAnnotations,
    });
  }

  get name(): string {
    return this.firstName + ' ' + this.lastName;
  }

  get middleInitial(): string {
    if (this.middleName && this.middleName.length > 0) {
      return this.middleName.substring(0, 1);
    }
    return '';
  }

  get fullName() {
    if (this.salutation) {
      return this.salutation + ' ' + this.firstName + ' ' + this.lastName;
    }
    return this.firstName + ' ' + this.lastName;
  }

  get formalName() {
    return this.lastName + ', ' + this.firstName;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Boolean */
  acceptSms?: boolean;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** String(25) */
  cellNumber?: string;
  /** DateTimeOffset */
  crtnTs?: Date;
  /** String(100) */
  email?: string;
  /** String(10) */
  extension?: string;
  /** String(50) */
  firstName!: string;
  /** DateTime */
  hireDate?: Date;
  /** String(50) */
  lastName!: string;
  /** String(50) */
  middleName?: string;
  /** String(100) */
  migratedEmail?: string;
  /** Guid FK proximityRole */
  proximityRoleId!: string;
  /** Binary */
  rowVersion!: any;
  /** String(20) */
  salutation?: string;
  /** String(25) */
  telephoneNumber?: string;
  /** String(50) */
  title?: string;
  /** String(50) */
  username!: string;
  /** Boolean */
  wasPopulatedFromUniformax?: boolean;
  /** Inv FK proximityUserId */
  accountAdmins!: AccountAdmin[];
  /** Inv FK proximityUserId */
  accountUsers!: AccountUser[];
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK proximityRoleId */
  proximityRole!: ProximityRole;
  /** Inv FK proximityUserId */
  proximityUserNotes!: ProximityUserNote[];
}

